// import('/node_modules/bootstrap-sass/assets/javascripts/bootstrap.js')

$(function () {
    Website.init();
    $(document).ready(function () {
        if (window.location.pathname.search('/trip/') === -1) {
            setTimeout(function () {
                addCollapsibles();
                loadFadingBlocks();
                // addSlider('header', 1);
            }, 1000);
        }
        wizardSettings();

        var selected = $('.new-trip-tab.selected').data('section');
        $('#' + selected).addClass('selected');

        $('.new-trip-tab').on('click', function () {
            $('.new-trip-tab-content.selected').removeClass('selected');
            $('.new-trip-tab.selected').removeClass('selected');
            $(this).addClass('selected');
            var trip = $(this).data('section');
            $('#' + trip).addClass('selected');
        });

    });

    function wizardSettings() {
        setTimeout(function () {
            $('a[href="#bookNowModal"]').click(function () {
                $('.steps .number').each(function () {
                    $(this).text($(this).text().substr(0, 1))
                })
            })
        }, 3000)


    }

    function loadFadingBlocks() {
        $('.js-main-block').css('opacity', 1);
        setTimeout(function () {
            $('.js-hidden-block.js-show-1').css('opacity', 1);
            setTimeout(function () {
                $('.js-hidden-block.js-show-2').css('opacity', 1);
                setTimeout(function () {
                    $('.js-hidden-block.js-show-3').css('opacity', 1);
                    setTimeout(function () {
                        $('.js-hidden-block').css('opacity', 1);
                    }, 200);
                }, 200);
            }, 200);
        }, 1000);
    }

    function addCollapsibles() {
        var $all = $('.collapsible');
        for (var i = 0; i < $all.length; i++) {
            if ($($all[i]).hasClass('active')) {
                $($all[i]).next().slideDown(200);
            }
            $($all[i]).on("click", function () {
                if ($(this).hasClass('active')) {
                    $(this).next().slideUp(200);
                } else {
                    $(this).next().slideDown(200);
                }
                $(this).toggleClass("active");
            });

            var $li_all = $($all[i]).next().children().children();
            for (var j = 0; j < $li_all.length; j++) {
                $($li_all[j]).on('click', function () {

                    var siblings = $(this).siblings();
                    for (var s = 0; s < siblings.length; s++) {
                        $(siblings[s]).removeClass('active');
                    }
                    $(this).toggleClass('active');

                });
            }
        }
    }

    function addSlider(sliderId, slidesToShow) {
        $('#' + sliderId).slick({
            centerMode: true,
            centerPadding: '0',
            slidesToShow: slidesToShow,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: true,
                        centerMode: true,
                        centerPadding: '0',
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: true,
                        centerMode: true,
                        centerPadding: '0',
                        slidesToShow: 1
                    }
                }
            ]
        });
    }
});

Website = {
    hide_thread: null,
    hide_splash_thread: null,
    init: function () {
        this.bindEvents();
        this.initSelect();
        this.makeAll(true);
    },
    bindEvents: function () {
        $('.n-splash').click(function () {
            Website.hideSplash();
            Website.hide_splash_thread && clearTimeout(Website.hide_splash_thread);
        });
        $('.n-loc-left .n-col').mouseover(function () {
            Website.hide_thread && clearTimeout(Website.hide_thread);
            var cls = $(this).data('highlight');
            $('.n-loc-right .n-pin').addClass('faded');
            $(cls).removeClass('faded');
        });
        $('.n-loc-left .n-col').mouseleave(function () {
            Website.hide_thread && clearTimeout(Website.hide_thread);
            Website.hide_thread = setTimeout(function () {
                $('.n-loc-right .n-pin').removeClass('faded');
            }, 500);
        });
        $('.n-facilities .n-col').click(function () {
            var target = $(this).data('target');
            $('.n-content-row').removeClass('n-wifi').removeClass('n-sim').removeClass('n-essentials').removeClass('n-lounge').removeClass('n-events').removeClass('n-delivery').removeClass('n-assistance');
            if ($(this).hasClass('active')) {
                $('.n-content-row').hide().removeClass(target);
                $('.n-content-row p').hide();
                $('.n-facilities .n-col').removeClass('active');
            } else {
                $('.n-facilities .n-col').removeClass('active');
                $(this).addClass('active');
                $('.n-content-row p').hide();
                $('.n-content-row').show().addClass(target.replace('.', ''));
                $('.n-content-row ' + target + '-desc').show();
            }
        });
        this.hide_splash_thread = setTimeout(function () {
            Website.hideSplash();
        }, 5000);


        $(document).on('change', '.trip-date-start', function () {
            window.location.href = $(this).find('.active').attr('data-url');
        });

        $(window).resize(function () {
            Website.makeAll(false);
        });

        $('.n-mobile-menu').click(function () {
            $('header').toggleClass('n-extended');
        });

        $('.n-trip-menu li .n-show-box').click(function () {
            !$(this).closest('li').hasClass('n-open') && $('.n-trip-menu li').removeClass('n-open');
            $(this).closest('li').toggleClass('n-open');
            $('.n-trip-menu li.n-open').length == 0 ? $('.n-trip-menu').removeClass('n-open') : $('.n-trip-menu').addClass('n-open');
        });

        $('.n-trip-close').click(function () {
            $(this).closest('li').toggleClass('n-open');
            $('.n-trip-menu').removeClass('n-open');
        });
    },
    makeAll: function (withBookForm) {
        this.makeRatio();
        this.makeImage();
        this.makeSlider();
        this.makeMobile();
        this.makeTruncateMulti();
        withBookForm && this.bookForm();
        this.scrollMenu();
        this.jumpToTop();
        this.closeMobileModal();
    },

    closeMobileModal: function () {
        $('.close-modal').click(function () {
            $('.n-student-centers .n-red-bg .n-facilities .n-content-row').css('display', 'none');
        });
    },

    jumpToTop: function () {
        $('.scroll-top').click(function () {
            $('body,html').animate({
                scrollTop: 0
            }, 500);
        });
    },

    scrollMenu: function () {

        function detectmobileorpad() {
            if (navigator.userAgent.match(/Android/i)
                || navigator.userAgent.match(/iPhone/i)
                || navigator.userAgent.match(/iPod/i)
                || navigator.userAgent.match(/iPad/i)
                || navigator.userAgent.match(/BlackBerry/i)
                || navigator.userAgent.match(/Windows Phone/i)
                || navigator.userAgent.match(/IEMobile/i)
            ) {
                return true;
            } else {
                return false;
            }
        };
        if (detectmobileorpad() == false) {
            $('.click-submenu1').click(function (event) {
                var hrefSplit = window.location.href.split('/');
                if (hrefSplit[3] == 'services') {
                    event.preventDefault();
                }
                var id = $('#students-centers');
                $('html, body').stop().animate({
                    scrollTop: id.offset().top
                }, 1000);
            });

            $('.click-submenu2').click(function (event) {
                var hrefSplit = window.location.href.split('/');
                if (hrefSplit[3] == 'services') {
                    event.preventDefault();
                }
                var id = $('#airport-transfers');
                $('html, body').stop().animate({
                    scrollTop: id.offset().top
                }, 1000);
            });
        } else {
            $('.click-submenu1').click(function () {
                $('header').removeClass('n-extended');
            });

            $('.click-submenu2').click(function () {
                $('header').removeClass('n-extended');
            });
        }
    },

    bookForm: function () {

        $('.your-info-button').click(function (event) {
            event.preventDefault();
        });
        $('.your-arrival-button').click(function (event) {
            event.preventDefault();
        });
        $('.your-departure-button').click(function (event) {
            event.preventDefault();
        });
        $('.add-message-button').click(function (event) {
            event.preventDefault();
        });

        function detectmobile() {
            if (navigator.userAgent.match(/Android/i)
                || navigator.userAgent.match(/iPhone/i)
                || navigator.userAgent.match(/iPod/i)
                || navigator.userAgent.match(/BlackBerry/i)
                || navigator.userAgent.match(/Windows Phone/i)
                || navigator.userAgent.match(/IEMobile/i)
            ) {
                return true;
            } else {
                return false;
            }
        }

        function detectmobileorpad() {
            if (navigator.userAgent.match(/Android/i)
                || navigator.userAgent.match(/iPhone/i)
                || navigator.userAgent.match(/iPod/i)
                || navigator.userAgent.match(/iPad/i)
                || navigator.userAgent.match(/BlackBerry/i)
                || navigator.userAgent.match(/Windows Phone/i)
                || navigator.userAgent.match(/IEMobile/i)
            ) {
                return true;
            } else {
                return false;
            }
        }

        function scrollTo(el) {
            $([document.documentElement, document.body]).animate({
                scrollTop: el.offset().top - 200
            }, 1000);
        }


        if (detectmobileorpad() === true) {
            $('.services-menu').click(function (event) {
                event.preventDefault();
            });
        }

        if (detectmobileorpad() === true) {
            $('.n-arrow').click(function () {
                $('.second-trip').css('display', 'block');
                $('.second-trip').toggleClass('open');
                $('.first-trip').css('display', 'none');
            });
        }

        $('.red').css('color', '#D3D3D3');

        // if (detectmobile() === true) {
        //     $('.book').css('display', 'none');
        //     $('.your-arrival').css('display', 'none');
        // }

        $('.book-button').click(function () {
            if (!$('.collapsible.info').hasClass('active')) {
                $('.your-info').parent().toggle('show');
            }
            $('.collapsible.info').add('.your-info li').addClass('active').removeClass('disabled');
            $('.your-info .collapsible-input').attr('disabled', false);

            $('.total.book-now').hide();
            $('.your-info-button').show()

            scrollTo($('.collapsible.info'))
        });


        function clearErrorMessages() {
            $('.alert-message').hide();
            $('#backend-error').text();
        }

        $('.your-info-button').click(function () {
            var $form = $('.your-info');

            clearErrorMessages();

            if ($form.valid()) {
                $.post('/book-a-transfer', $form.serialize(), function (data) {
                    if (data.status === 'success') {
                        var values = data.data;

                        if (! $('.collapsible.your-arrival').hasClass('active')) {
                            $('.your-arrival-color').parent().toggle('show');
                        }

                        $('.your-info .collapsible-input').attr('disabled', true);
                        $('.your-arrival-color .collapsible-input').attr('disabled', false);

                        $('.your-info li').removeClass('active').addClass('disabled');
                        $('.collapsible.info').addClass('disabled');
                        $('.collapsible.your-arrival').add('.your-arrival-color li').addClass('active').removeClass('disabled');

                        $('.your-info-button').hide();
                        $('.your-arrival-button').show();
                        $('.your-arrival-back-button').show();

                        $('.studentId').val(values.id);

                        scrollTo($('.collapsible.your-arrival'))
                    } else {
                        $('.alert-message').show();
                        $('#backend-error').text(data.messages);
                    }
                });
            }
        });
        $('.your-arrival-button').click(function () {
            var $form = $('.your-arrival-color');

            clearErrorMessages();

            if ($form.valid()) {
                $.post('/book-a-transfer', $form.serialize(), function (data) {
                    if (data.status === 'success') {
                        var values = data.data;

                        if (! $('.collapsible.your-departure').hasClass('active')) {
                            $('.your-departure-color').parent().toggle('show');
                        }

                        $('.your-arrival-color .collapsible-input').attr('disabled', true);
                        $('.your-departure-color .collapsible-input').attr('disabled', false);

                        $('.your-arrival-color li').removeClass('active').addClass('disabled');
                        $('.collapsible.your-arrival').addClass('disabled');
                        $('.collapsible.your-departure').add('.your-departure-color li').addClass('active').removeClass('disabled');

                        $('.your-arrival-button').hide();
                        $('.your-departure-button').show();
                        $('.your-arrival-back-button').hide();
                        $('.your-departure-back-button').show();

                        $('.studentId').val(values.id);

                        scrollTo($('.collapsible.your-departure'))
                    } else {
                        $('.alert-message').show();
                        $('#backend-error').text(data.messages);
                    }
                });
            }
        });
        $('.your-departure-button').click(function () {
            var $form = $('.your-departure-color');

            clearErrorMessages();

            if ($form.valid()) {
                $.post('/book-a-transfer', $form.serialize(), function (data) {
                    if (data.status === 'success') {
                        var values = data.data;

                        if (! $('.collapsible.add-message').hasClass('active')) {
                            $('.add-message-color').parent().toggle('show');
                        }

                        $('.your-departure-color .collapsible-input').attr('disabled', true);
                        $('.add-message-color .collapsible-input').attr('disabled', false);

                        $('.your-departure-color li').removeClass('active').addClass('disabled');
                        $('.collapsible.your-departure').addClass('disabled');
                        $('.collapsible.add-message').add('.add-message-color li').addClass('active').removeClass('disabled');

                        $('.your-departure-button').hide();
                        $('.add-message-button').show();
                        $('.your-departure-back-button').hide();
                        $('.add-message-back-button').show();

                        $('.studentId').val(values.id);

                        scrollTo($('.collapsible.add-message'))
                    } else {
                        $('.alert-message').show();
                        $('#backend-error').text(data.messages);
                    }
                });
            }
        });
        $('.add-message-button').click(function () {
            var $form = $('.add-message-color');

            clearErrorMessages();

            if ($form.valid()) {
                $.post('/book-a-transfer', $form.serialize(), function (data) {
                    if (data.status === 'success') {
                        var values = data.data;

                        $('.add-message-color .collapsible-input').attr('disabled', true);

                        $('.add-message-color li').removeClass('active').addClass('disabled');
                        $('.collapsible.add-message').addClass('disabled');

                        $('.add-message-button').hide();
                        $('.add-message-back-button').hide();
                        $('.panel.booked').show();

                        $('.studentId').val(values.id);
                    } else {
                        $('.alert-message').show();
                        $('#backend-error').text(data.messages);
                    }
                });
            }
        });

        $('.your-arrival-back-button').click(function () {
            if (!$('.collapsible.info').hasClass('active')) {
                $('.your-info').parent().toggle('show');
            }
            $('.collapsible.info').add('.your-info li').addClass('active').removeClass('disabled');
            $('.your-info .collapsible-input').attr('disabled', false);

            $('.your-arrival-color li').removeClass('active').addClass('disabled');
            $('.collapsible.your-arrival').addClass('disabled');
            $('.your-arrival-color .collapsible-input').attr('disabled', true);

            $('.your-info-button').show();
            $('.your-arrival-button').hide();
            $('.your-arrival-back-button').hide();

            scrollTo($('.collapsible.info'))
        });

        $('.your-departure-back-button').click(function () {
            if (!$('.collapsible.your-arrival').hasClass('active')) {
                $('.your-arrival-color').parent().toggle('show');
            }
            $('.collapsible.your-arrival').add('.your-arrival-color li').addClass('active').removeClass('disabled');
            $('.your-arrival-color .collapsible-input').attr('disabled', false);

            $('.your-departure-color li').removeClass('active').addClass('disabled');
            $('.collapsible.your-departure').addClass('disabled');
            $('.your-departure-color .collapsible-input').attr('disabled', true);

            $('.your-arrival-button').show();
            $('.your-departure-button').hide();
            $('.your-arrival-back-button').show();
            $('.your-departure-back-button').hide();

            scrollTo($('.collapsible.your-arrival'))
        });

        $('.add-message-back-button').click(function () {
            if (!$('.collapsible.your-departure').hasClass('active')) {
                $('.your-departure-color').parent().toggle('show');
            }
            $('.collapsible.your-departure').add('.your-departure-color li').addClass('active').removeClass('disabled');
            $('.your-departure-color .collapsible-input').attr('disabled', false);

            $('.add-message-color li').removeClass('active').addClass('disabled');
            $('.collapsible.add-message').addClass('disabled');
            $('.add-message-color .collapsible-input').attr('disabled', true);


            $('.your-departure-button').show();
            $('.add-message-button').hide();
            $('.your-departure-back-button').show();
            $('.add-message-back-button').hide();

            scrollTo($('.collapsible.your-departure'))
        });
    },

    hideSplash: function () {
        if ($('.n-splash').is(':visible')) {
            $.cookie('hide_splash', 1, {expires: 60, path: '/'});
            $('.n-splash').fadeOut(300, function () {
                $('.n-splash').remove();
            });
        }
    },
    makeTruncateMulti: function () {
        $('.truncate-multi').each(function () {
            var elem = $(this);
            if (elem.data('text-original')) {
                elem.text(elem.data('text-original'));
                var wordArray = $(this).data('text-original').split(' ');
                while (elem[0].scrollHeight > elem[0].offsetHeight) {
                    wordArray.pop();
                    elem.text(wordArray.join(' ') + '...');
                }
                elem.css('opacity', 1);
            }
        });
    },
    makeRatio: function () {
        $('.n-make-ratio').each(function () {
            // var i = $(window).outerWidth() < 768 ? '-mobile' : '';
            var i = window.matchMedia('(max-width: 768px)').matches ? '-mobile' : '';
            var aspect_ratio = $(this).data('aspect-ratio' + i) ? $(this).data('aspect-ratio' + i).split(':') : $(this).data('aspect-ratio').split(':');
            var ar = aspect_ratio[0] / aspect_ratio[1];
            var width = $(this).width();
            $(this).height(width / ar);
        });
    },
    makeMobile: function () {
        if ($(window).width() < 768) {
            $('.n-trip-details .n-description').css('padding-top', $('.n-trip-details .n-image').height() + 120);
        } else {
            $('.n-trip-details .n-description').css('padding-top', '0');
        }
    },
    makeSlider: function () {
        if ($(window).width() < 220 * 5) {
            $('.n-trip-list').each(function () {
                var w = 0;
                var h = 0;
                $('> li', $(this)).each(function () {
                    w = w + $(this).outerWidth();
                    if (h < $(this).outerHeight()) {
                        h = $(this).outerHeight();
                    }
                });
                $(this).width(w).height(h);
            });
        } else {
            $('.n-trip-list').css('width', 'auto').css('height', 'auto');
        }
    },
    makeImage: function () {
        $('.n-make-image').each(function () {
            var src = $(this).data('src');
            $(this).css('background-image', 'url("' + src + '")');
            $('img', $(this)).hide();
        });
    },
    initSelect: function () {
        $('.n-select select').change(function () {
            var v = $('option:selected', $(this)).text();
            $('.n-select-head', $(this).closest('.n-select')).text(v);
        });
        $('.n-select').each(function () {
            var v = $('option:selected', $(this)).text();
            $('.n-select-head', $(this)).text(v);
        });
    }
};
